import React from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import * as DomUtils from '../utils/DomUtils';

const POPOVER = 'vuCard-popover';
const POPOVER_POINTER = 'vuCard-popover-pointer';

export default class PopoverWidget extends React.Component {
  constructor() {
    super();

    this.positionWidget = this.positionWidget.bind(this);
    this.closeOnOutsideBoxClick = this.closeOnOutsideBoxClick.bind(this);
  }

  componentDidMount() {
    document.addEventListener('click', this.closeOnOutsideBoxClick);
    this.$popover = $(this.root);

    this.positionWidget();
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.closeOnOutsideBoxClick);
  }

  render() {
    const {children, rendererId} = this.props;
    return (
      <div id={POPOVER}
           data-renderer-id={rendererId}
           ref={(root) => {
             this.root = root;
           }}
           onClick={this.onOverlayClick}
           onResize={this.positionWidget}>
        <div className={POPOVER_POINTER}/>
        {children}
      </div>
    );
  }

  positionWidget() {
    const baseOffset = $(this.props.hoverComponentDOM).offset();
    const baseOffsetWidth = $(this.props.hoverComponentDOM)[0].offsetWidth;
    let baseOffsetHeight = $(this.props.hoverComponentDOM)[0].offsetHeight;
    if (this.props.displayMode === 'poster') {
      baseOffsetHeight += 124;
    }
    const topSpace = (baseOffset.top - $(window).scrollTop());
    let offset;

    let windowWidth = $(window).width(),
        popoverWidth = this.$popover.width();
    const defaultCenteredOffsetLeft = (baseOffset.left + (baseOffsetWidth / 2) - (popoverWidth / 2));
    let defaultOffsetLeft;
    if (defaultCenteredOffsetLeft + popoverWidth <= windowWidth) {
      defaultOffsetLeft = defaultCenteredOffsetLeft;
    } else {
      defaultOffsetLeft = windowWidth - popoverWidth;
    }

    let offsetLeft = Math.max(0, defaultOffsetLeft),
      bottomOffsetTop = baseOffset.top + 30,
      topOffsetBottom = baseOffset.top - (baseOffsetHeight * 2) - this.$popover.height();

    const bottomDisplayBottom = topSpace + baseOffsetHeight + this.$popover.height();
    const willFitBelow = (bottomDisplayBottom <= $(window).innerHeight());
    const isMorePlaceForBelow = ($(window).innerHeight() - topSpace + baseOffsetHeight) > topSpace;

    if (willFitBelow || isMorePlaceForBelow) {
      offset = {
        left: offsetLeft,
        top: bottomOffsetTop
      };
      this.$popover.addClass('position-bottom');
    } else {
      offset = {
        left: offsetLeft,
        top: topOffsetBottom
      };
      this.$popover.addClass('position-top');
    }

    this.$popover.offset(offset);
  }

  closeOnOutsideBoxClick(e) {
    if (!DomUtils.isElementChildOf(e.target, this.root)) {
      this.props.onClose();
    }
  }
}


PopoverWidget.displayName = 'PopoverWidget';
PopoverWidget.propTypes = {
  rendererId: PropTypes.number,
  hoverComponentDOM: PropTypes.object.isRequired,
  displayMode: PropTypes.string.isRequired,
  frameUrl: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  hasVideo: PropTypes.bool
};
